//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoteTab from "./actions-panel/note-tab";
import ChecklistTab from "./actions-panel/checklist-tab";
import EmailTab from "./actions-panel/email-tab";
import FollowUpTab from "./actions-panel/follow-up-tab";
import VueContentLoading from "vue-content-loading";
import FilesTab from "./actions-panel/file-tab";
import { Fragment } from "vue-fragment";
import ScrollableContainer from "@Shared/components/general/scrollable-container";
import { capitalize, isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ActionsPanel",
  components: {
    NoteTab,
    ChecklistTab,
    EmailTab,
    FollowUpTab,
    FilesTab,
    Fragment,
    VueContentLoading,
    ScrollableContainer
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    profile: {
      type: Object,
      default: () => ({})
    },
    username: {
      type: String,
      default: null
    },
    applications: {
      type: Object,
      default: () => ({})
    },
    currentTab: {
      type: String,
      required: true
    },
    tabData: {
      type: Object,
      default: () => ({})
    },
    boardId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      selectedTabData: this.tabData,
      collapsed: false
    };
  },
  computed: {
    tabs() {
      return [{
        name: "note",
        label: this.$t("client-profile.actions.addNote")
      }, {
        name: "checklist",
        label: this.$t("client-profile.actions.createChecklist")
      }, {
        name: "follow-up",
        label: this.$t("client-profile.actions.createActivity")
      }, {
        name: "email",
        label: capitalize(this.$tc("global.words.email", 1))
      }, {
        name: "files",
        label: capitalize(this.$tc("global.words.file", 2))
      }];
    }
  },
  watch: {
    tabData(val) {
      if (!isEmpty(val)) {
        //Something is focusing the action pane, lets not show the collapse message
        this.collapsed = true;
        this.scrollToActionPanel();
      }
      this.selectedTabData = val;
    }
  },
  methods: {
    activeItem(tab) {
      return this.currentTab === tab;
    },
    setCurrentTab(tab) {
      this.collapsed = true;
      this.$emit("tab", tab);
    },
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    getCollapseText() {
      const collapseTextMap = {
        note: this.$t("client-profile.actions.takeNotes"),
        checklist: this.$t("client-profile.actions.createAChecklist"),
        "follow-up": this.$t("client-profile.actions.createAnActivity"),
        email: this.$t("email.actions.sendAnEmail"),
        files: this.$t("client-profile.actions.uploadFiles")
      };
      return collapseTextMap[this.currentTab];
    },
    scrollToActionPanel() {
      this.$nextTick(() => {
        $("#page").scrollTo("#actions-pane-container", 0, {
          force: true,
          cancelable: true,
          offset: -200
        });
      });
    },
    clearData() {
      this.$parent.tabData = {};
    },
    handleSubmit() {
      this.$emit("submit");
    }
  }
});